module.exports = __webpack_public_path__ + "static/media/entercode.d14a9534.svg";